import { apiRequestHandler, apiHost } from '.';
import { HttpMethods, APIContexts } from 'enums';
import axios from 'axios';

const apiContext = `${APIContexts.SCHEDULE}/`;

export const GetChannelSchedulesAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetChannelSchedules';
  const endpoint =
    `${apiHost}${apiContext}${api}?ChannelId=${queryParams.channelId}` +
    (queryParams.startDate ? `&Start=${queryParams.startDate}` : '') +
    (queryParams.endDate ? `&End=${queryParams.endDate}` : '') +
    (queryParams.pageNumber ? `&PageNumber=${queryParams.pageNumber}` : '') +
    (queryParams.pageSize ? `&PageSize=${queryParams.pageSize}` : '') +
    (queryParams.isPresentation
      ? `&IsPresentation=${queryParams.isPresentation}`
      : '');

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetViewSchedulesListAPI = ({ onSuccess, ...rest }) => {
  const api = 'viewscheduleslist';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const AddChannelScheduleSessionAPI = ({ queryParams, ...rest }) => {
  const api = 'AddChannelScheduleSession';
  const endpoint =
    `${apiHost}${apiContext}${api}?ChannelID=${queryParams.channelId}` +
    (queryParams.startDate ? `&StartDate=${queryParams.startDate}` : '') +
    (queryParams.endDate ? `&EndDate=${queryParams.endDate}` : '');

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    ...rest,
  });
};

export const GetChannelScheduleSessionAPI = ({ onSuccess, ...rest }) => {
  const api = 'GetChannelScheduleSession';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ExportChannelScheduleAPI = ({
  queryParams,
  responseType,
  ...rest
}) => {
  const api = 'ExportChannelSchedule';
  const endpoint =
    `${apiHost}${apiContext}${api}?ChannelID=${queryParams.channelId}` +
    (queryParams.startDate ? `&Start=${queryParams.startDate}` : '') +
    (queryParams.endDate ? `&End=${queryParams.endDate}` : '');

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    responseType: responseType,
    ...rest,
  });
};

export const GetTitleGroupProgramsAPI = ({ queryParams, ...rest }) => {
  const api = 'GetTitleGroupPrograms';
  const { id, channelId, start, end } = queryParams;
  const endpoint = `${apiHost}${apiContext}${api}?searchKey=${id}&channelId=${channelId}&start=${start}&end=${end}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ImportHistoricalScheduleAPI = (file, start, end, schedules) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append(
    'schedule',
    JSON.stringify({ slots: schedules.channelSchedulePrograms }),
  );
  const api = 'ImportHistoricalSchedule';
  const url = `${apiHost}${apiContext}${api}?channelId=${schedules.channelID}&start=${start}&end=${end}&totalSlots=${schedules.channelSchedulePrograms.length}`;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const SaveHistoricalSchedulesAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'SaveHistoricalSchedule';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    payload: queryParams,
    method: HttpMethods.POST,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ExportOutputFileAPI = ({ scheduleID, responseType, ...rest }) => {
  const api = 'ExportScheduleOutput';
  const endpoint = `${apiHost}${apiContext}${api}?scheduleID=${scheduleID}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    responseType: responseType,
    ...rest,
  });
};

export const PublishScheduleAPI = ({ scheduleId, force = false, ...rest }) => {
  const api = 'publish';
  const endpoint = `${apiHost}${apiContext}${api}/${scheduleId}?force=${force}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    onSuccess: (res) => res,
    ...rest,
  });
};

export const GetScheduleProgramVersionsAPI = ({ requestBody, ...rest }) => {
  const api = 'GetScheduleProgramVersions';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ApplyProgramSchedulesVersionAPI = ({
  scheduleId,
  onSuccess,
  ...rest
}) => {
  const api = 'ApplyScheduleProgramVersions';
  const endpoint = `${apiHost}${apiContext}${api}/${scheduleId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const AddProgramSchedulesVersionAPI = ({
  requestBody,
  onSuccess,
  ...rest
}) => {
  const api = 'AddVersionToAsset';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ExportInteractiveScheduleAPI = ({
  queryParams,
  responseType,
  ...rest
}) => {
  const api = 'ExportInteractiveSchedule';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    payload: queryParams,
    method: HttpMethods.POST,
    onSuccess: (res) => onSuccess(res),
    responseType: responseType,
    ...rest,
  });
};

export const UpdateDraftScheduleProgramAPI = ({
  draftScheduleProgramId,
  requestBody,
  onSuccess,
  ...rest
}) => {
  const api = 'Programs/';
  const endpoint = `${apiHost}${apiContext}${api}${draftScheduleProgramId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.PUT,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res[0]),
    ...rest,
  });
};

export const GetDraftScheduleByIdAPI = ({
  draftScheduleParentId,
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetCalendarDetails/';
  const query = new URLSearchParams(queryParams).toString();
  const endpoint = `${apiHost}${apiContext}${api}${draftScheduleParentId}?${query}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GeneratePresentationScheduleAPI = ({
  draftScheduleParentId,
  requestBody,
  onSuccess,
  ...rest
}) => {
  const api = '/Presentation';
  const endpoint = `${apiHost}${apiContext}${draftScheduleParentId}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ImportScheduleBreakPatternsAPI = (
  file,
  channelId,
  scheduleDate,
  draftScheduleProgramId,
  isLive,
) => {
  const formData = new FormData();
  formData.append('file', file);

  const api = 'ImportBreakPattern';
  const url = `${apiHost}${apiContext}${api}?channelId=${channelId}&scheduleDate=${scheduleDate}&draftScheduleProgramId=${draftScheduleProgramId}&isLive=${isLive}`;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const ImportScheduleVoiceOverAPI = (file, channelId, scheduleDate) => {
  const formData = new FormData();
  formData.append('file', file);

  const api = 'Presentation/VoiceOver';
  const url = `${apiHost}${apiContext}${api}?channelId=${channelId}&date=${scheduleDate}`;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const DownloadImportedFileAPI = ({
  draftScheduleProgramId,
  responseType,
  ...rest
}) => {
  const api = 'DownloadImportFile';
  const endpoint = `${apiHost}${apiContext}${api}/${draftScheduleProgramId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    responseType,
    ...rest,
  });
};
